// block icon.
export const VerticalBlockIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 512 512">
		<defs>
			<style>{ '.st1{fill:#f26c0d}' }</style>
		</defs>
		<path
			d="M413 1H99C64.5 1 36.5 29 36.5 63.5v385c0 34.5 28 62.5 62.5 62.5h314c34.5 0 62.5-28 62.5-62.5v-385C475.5 29 447.5 1 413 1Zm17.5 447.5c0 9.6-7.9 17.5-17.5 17.5H99c-9.6 0-17.5-7.9-17.5-17.5v-385C81.5 53.9 89.4 46 99 46h314c9.6 0 17.5 7.9 17.5 17.5v385Z"
			className="st1"
		/>
		<path
			d="M156.9 189.9c12.6.2 25.2 0 37.8 0s25.2.1 37.8 0c15.1-.2 27.8-11.6 30-26.6 2.2-15.1-7-29.6-21.7-33.9-2.5-.7-3.3-1.7-3.8-4.3-2.7-15.8-15.5-27.8-31.7-30.1-15.2-2.1-30.7 6.1-37.8 20.3-.4.9-.8 1.1-1.8.8-13.6-3.4-26 9-22.4 22.4.3 1.2 0 1.6-.9 2.3-9.3 6.5-13.5 15.4-11.8 26.6 2 13.1 12.9 22.3 26.1 22.5ZM234.8 203.4 224.2 214c-3 3-3 7.8 0 10.8 3 3 7.8 3 10.8 0l10.6-10.6c3-3 3-7.8 0-10.8-3-3-7.8-3-10.8 0ZM196.5 203.4 185.9 214c-3 3-3 7.8 0 10.8 3 3 7.8 3 10.8 0l10.6-10.6c3-3 3-7.8 0-10.8-3-3-7.8-3-10.8 0ZM158.2 203.4 147.6 214c-3 3-3 7.8 0 10.8 3 3 7.8 3 10.8 0l10.6-10.6c3-3 3-7.8 0-10.8-3-3-7.8-3-10.8 0ZM364.4 112.8h-53.1c-9.5 0-17.2 7.7-17.2 17.2s7.7 17.2 17.2 17.2h53.1c9.5 0 17.2-7.7 17.2-17.2s-7.7-17.2-17.2-17.2ZM364.4 174.5h-53.1c-9.5 0-17.2 7.7-17.2 17.2s7.7 17.2 17.2 17.2h53.1c9.5 0 17.2-7.7 17.2-17.2s-7.7-17.2-17.2-17.2ZM364.4 313.4H147.6c-9.5 0-17.2 7.7-17.2 17.2s7.7 17.2 17.2 17.2h216.8c9.5 0 17.2-7.7 17.2-17.2s-7.7-17.2-17.2-17.2ZM364.4 377.4H147.6c-9.5 0-17.2 7.7-17.2 17.2s7.7 17.2 17.2 17.2h216.8c9.5 0 17.2-7.7 17.2-17.2s-7.7-17.2-17.2-17.2Z"
			className="st1"
		/>
	</svg>
);
// preview image.
export const VerticalPreview = () => (
	<svg viewBox="0 0 236 158" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect
			x={ 0.75 }
			y={ 0.75 }
			width={ 234.5 }
			height={ 156.5 }
			rx={ 3.25 }
			fill="white"
		/>
		<rect
			x={ 0.75 }
			y={ 0.75 }
			width={ 234.5 }
			height={ 156.5 }
			rx={ 3.25 }
			stroke="#9EA9B2"
			strokeWidth={ 1.5 }
		/>
		<path
			d="M83 22.575C83 20.4183 83 19.34 83.67 18.67C84.34 18 85.4183 18 87.575 18H148.575C150.732 18 151.81 18 152.48 18.67C153.15 19.34 153.15 20.4183 153.15 22.575V135.425C153.15 137.582 153.15 138.66 152.48 139.33C151.81 140 150.732 140 148.575 140H87.575C85.4183 140 84.34 140 83.67 139.33C83 138.66 83 137.582 83 135.425V22.575Z"
			fill="white"
		/>
		<path
			d="M148.575 139L148.575 140H87.575L87.5752 139H148.575ZM152.15 135.425V22.5752C152.15 21.4686 152.148 20.739 152.075 20.1982C152.006 19.6862 151.891 19.4952 151.772 19.377C151.654 19.2589 151.463 19.144 150.952 19.0752C150.411 19.0025 149.682 19 148.575 19H87.5752C86.4686 19 85.739 19.0025 85.1982 19.0752C84.6862 19.144 84.4952 19.2587 84.377 19.377C84.2587 19.4952 84.144 19.6862 84.0752 20.1982C84.0207 20.6038 84.006 21.1153 84.002 21.8125L84 22.5752V135.425C84 136.531 84.0025 137.261 84.0752 137.802C84.144 138.314 84.2587 138.505 84.377 138.623C84.4952 138.741 84.6862 138.856 85.1982 138.925C85.739 138.998 86.4686 139 87.5752 139L87.575 140L86.8154 139.999C85.2739 139.991 84.3887 139.926 83.8008 139.448L83.67 139.33C83 138.66 83 137.582 83 135.425V22.575C83 20.4183 83 19.34 83.67 18.67C84.2562 18.0838 85.1551 18.0101 86.8154 18.001L87.575 18H148.575L149.335 18.001C150.995 18.0101 151.894 18.0838 152.48 18.67C153.15 19.34 153.15 20.4183 153.15 22.575V135.425L153.148 136.185C153.139 137.845 153.066 138.744 152.48 139.33L152.35 139.448C151.762 139.927 150.876 139.991 149.335 139.999L148.575 140L148.575 139C149.682 139 150.411 138.998 150.952 138.925C151.463 138.856 151.654 138.741 151.772 138.623C151.891 138.505 152.006 138.314 152.075 137.802C152.148 137.261 152.15 136.531 152.15 135.425Z"
			fill="#58707F"
		/>
		<path
			d="M100.063 26.7608C100.063 25.9186 100.745 25.2358 101.588 25.2358H132.088C132.93 25.2358 133.613 25.9186 133.613 26.7608C133.613 27.603 132.93 28.2858 132.088 28.2858H101.588C100.745 28.2858 100.063 27.603 100.063 26.7608Z"
			fill="#58707F"
		/>
		<path
			d="M103.494 30.5733C103.494 30.1522 103.835 29.8108 104.256 29.8108H113.406C113.827 29.8108 114.169 30.1522 114.169 30.5733C114.169 30.9944 113.827 31.3358 113.406 31.3358H104.256C103.835 31.3358 103.494 30.9944 103.494 30.5733Z"
			fill="#58707F"
		/>
		<path
			d="M114.931 30.5733C114.931 30.1522 115.273 29.8108 115.694 29.8108H129.419C129.84 29.8108 130.181 30.1522 130.181 30.5733C130.181 30.9944 129.84 31.3358 129.419 31.3358H115.694C115.273 31.3358 114.931 30.9944 114.931 30.5733Z"
			fill="#58707F"
		/>
		<path
			d="M90.15 97.6733C90.15 98.5155 89.4673 99.1983 88.625 99.1983C87.7828 99.1983 87.1 98.5155 87.1 97.6733C87.1 96.8311 87.7828 96.1483 88.625 96.1483C89.4673 96.1483 90.15 96.8311 90.15 97.6733Z"
			fill="#58707F"
		/>
		<path
			d="M90.9125 97.6732C90.9125 97.2521 91.2539 96.9107 91.675 96.9107H97.775C98.1962 96.9107 98.5375 97.2521 98.5375 97.6732C98.5375 98.0943 98.1962 98.4357 97.775 98.4357H91.675C91.2539 98.4357 90.9125 98.0943 90.9125 97.6732Z"
			fill="#58707F"
		/>
		<path
			d="M108.831 97.6732C108.831 98.5154 108.149 99.1982 107.306 99.1982C106.464 99.1982 105.781 98.5154 105.781 97.6732C105.781 96.831 106.464 96.1482 107.306 96.1482C108.149 96.1482 108.831 96.831 108.831 97.6732Z"
			fill="#58707F"
		/>
		<path
			d="M109.594 97.673C109.594 97.2519 109.935 96.9105 110.356 96.9105H121.031C121.453 96.9105 121.794 97.2519 121.794 97.673C121.794 98.0942 121.453 98.4355 121.031 98.4355H110.356C109.935 98.4355 109.594 98.0942 109.594 97.673Z"
			fill="#58707F"
		/>
		<path
			d="M132.088 97.6732C132.088 98.5154 131.405 99.1982 130.563 99.1982C129.72 99.1982 129.038 98.5154 129.038 97.6732C129.038 96.831 129.72 96.1482 130.563 96.1482C131.405 96.1482 132.088 96.831 132.088 97.6732Z"
			fill="#58707F"
		/>
		<path
			d="M132.85 97.673C132.85 97.2519 133.191 96.9105 133.613 96.9105H147.338C147.759 96.9105 148.1 97.2519 148.1 97.673C148.1 98.0942 147.759 98.4355 147.338 98.4355H133.613C133.191 98.4355 132.85 98.0942 132.85 97.673Z"
			fill="#58707F"
		/>
		<path
			d="M87.5746 106.442C87.5746 105.81 88.0867 105.298 88.7184 105.298H104.731C105.363 105.298 105.875 105.81 105.875 106.442C105.875 107.074 105.363 107.586 104.731 107.586H88.7184C88.0867 107.586 87.5746 107.074 87.5746 106.442Z"
			fill="#58707F"
		/>
		<path
			d="M133.325 106.442C133.325 105.81 133.837 105.298 134.468 105.298H147.431C148.063 105.298 148.575 105.81 148.575 106.442C148.575 107.074 148.063 107.586 147.431 107.586H134.468C133.837 107.586 133.325 107.074 133.325 106.442Z"
			fill="#58707F"
		/>
		<path
			d="M87.5746 112.923C87.5746 112.502 87.916 112.161 88.3371 112.161H95.9621C96.3832 112.161 96.7246 112.502 96.7246 112.923C96.7246 113.344 96.3832 113.686 95.9621 113.686H88.3371C87.916 113.686 87.5746 113.344 87.5746 112.923Z"
			fill="#58707F"
		/>
		<path
			d="M119.6 112.923C119.6 114.187 118.575 115.211 117.312 115.211C116.049 115.211 115.025 114.187 115.025 112.923C115.025 111.66 116.049 110.636 117.312 110.636C118.575 110.636 119.6 111.66 119.6 112.923Z"
			fill="#58707F"
		/>
		<path
			d="M134.85 112.923C134.85 112.502 135.191 112.161 135.612 112.161H140.187C140.608 112.161 140.95 112.502 140.95 112.923C140.95 113.344 140.608 113.686 140.187 113.686H135.612C135.191 113.686 134.85 113.344 134.85 112.923Z"
			fill="#58707F"
		/>
		<path
			d="M142.475 112.923C142.475 112.502 142.816 112.161 143.237 112.161H147.812C148.233 112.161 148.575 112.502 148.575 112.923C148.575 113.344 148.233 113.686 147.812 113.686H143.237C142.816 113.686 142.475 113.344 142.475 112.923Z"
			fill="#58707F"
		/>
		<path
			d="M87.5746 119.786C87.5746 119.365 87.916 119.023 88.3371 119.023H99.0121C99.4332 119.023 99.7746 119.365 99.7746 119.786C99.7746 120.207 99.4332 120.548 99.0121 120.548H88.3371C87.916 120.548 87.5746 120.207 87.5746 119.786Z"
			fill="#58707F"
		/>
		<path
			d="M119.6 119.786C119.6 121.049 118.575 122.073 117.312 122.073C116.049 122.073 115.025 121.049 115.025 119.786C115.025 118.523 116.049 117.498 117.312 117.498C118.575 117.498 119.6 118.523 119.6 119.786Z"
			fill="#58707F"
		/>
		<path
			d="M134.85 119.786C134.85 119.365 135.191 119.023 135.612 119.023H140.187C140.608 119.023 140.95 119.365 140.95 119.786C140.95 120.207 140.608 120.548 140.187 120.548H135.612C135.191 120.548 134.85 120.207 134.85 119.786Z"
			fill="#58707F"
		/>
		<path
			d="M142.475 119.786C142.475 119.365 142.816 119.023 143.237 119.023H147.812C148.233 119.023 148.575 119.365 148.575 119.786C148.575 120.207 148.233 120.548 147.812 120.548H143.237C142.816 120.548 142.475 120.207 142.475 119.786Z"
			fill="#58707F"
		/>
		<path
			d="M87.5746 126.648C87.5746 126.227 87.916 125.886 88.3371 125.886H97.4871C97.9082 125.886 98.2496 126.227 98.2496 126.648C98.2496 127.069 97.9082 127.411 97.4871 127.411H88.3371C87.916 127.411 87.5746 127.069 87.5746 126.648Z"
			fill="#58707F"
		/>
		<path
			d="M119.6 126.648C119.6 127.912 118.575 128.936 117.312 128.936C116.049 128.936 115.025 127.912 115.025 126.648C115.025 125.385 116.049 124.361 117.312 124.361C118.575 124.361 119.6 125.385 119.6 126.648Z"
			fill="#58707F"
		/>
		<path
			d="M134.85 126.648C134.85 126.227 135.191 125.886 135.612 125.886H140.187C140.608 125.886 140.95 126.227 140.95 126.648C140.95 127.069 140.608 127.411 140.187 127.411H135.612C135.191 127.411 134.85 127.069 134.85 126.648Z"
			fill="#58707F"
		/>
		<path
			d="M142.475 126.648C142.475 126.227 142.816 125.886 143.237 125.886H147.812C148.233 125.886 148.575 126.227 148.575 126.648C148.575 127.069 148.233 127.411 147.812 127.411H143.237C142.816 127.411 142.475 127.069 142.475 126.648Z"
			fill="#58707F"
		/>
		<path
			d="M87.5746 133.511C87.5746 133.09 87.916 132.748 88.3371 132.748H97.4871C97.9082 132.748 98.2496 133.09 98.2496 133.511C98.2496 133.932 97.9082 134.273 97.4871 134.273H88.3371C87.916 134.273 87.5746 133.932 87.5746 133.511Z"
			fill="#58707F"
		/>
		<path
			d="M119.6 133.511C119.6 134.774 118.575 135.798 117.312 135.798C116.049 135.798 115.025 134.774 115.025 133.511C115.025 132.248 116.049 131.223 117.312 131.223C118.575 131.223 119.6 132.248 119.6 133.511Z"
			fill="#58707F"
		/>
		<path
			d="M134.85 133.511C134.85 133.09 135.191 132.748 135.612 132.748H140.187C140.608 132.748 140.95 133.09 140.95 133.511C140.95 133.932 140.608 134.273 140.187 134.273H135.612C135.191 134.273 134.85 133.932 134.85 133.511Z"
			fill="#58707F"
		/>
		<path
			d="M142.475 133.511C142.475 133.09 142.816 132.748 143.237 132.748H147.812C148.233 132.748 148.575 133.09 148.575 133.511C148.575 133.932 148.233 134.273 147.812 134.273H143.237C142.816 134.273 142.475 133.932 142.475 133.511Z"
			fill="#58707F"
		/>
		<path
			d="M106.637 56.4983C106.637 56.0772 106.978 55.7358 107.4 55.7358H116.55C116.971 55.7358 117.312 56.0772 117.312 56.4983C117.312 56.9194 116.971 57.2608 116.55 57.2608H107.4C106.978 57.2608 106.637 56.9194 106.637 56.4983Z"
			fill="#58707F"
		/>
		<path
			d="M119.6 56.4983C119.6 56.0772 119.941 55.7358 120.362 55.7358H129.512C129.933 55.7358 130.275 56.0772 130.275 56.4983C130.275 56.9194 129.933 57.2608 129.512 57.2608H120.362C119.941 57.2608 119.6 56.9194 119.6 56.4983Z"
			fill="#58707F"
		/>
		<path
			d="M102.825 60.3108C102.825 59.8897 103.166 59.5483 103.587 59.5483H133.325C133.746 59.5483 134.087 59.8897 134.087 60.3108C134.087 60.7319 133.746 61.0733 133.325 61.0733H103.587C103.166 61.0733 102.825 60.7319 102.825 60.3108Z"
			fill="#58707F"
		/>
		<path
			d="M100.537 67.9358C100.537 67.5147 100.878 67.1733 101.3 67.1733H135.612C136.033 67.1733 136.375 67.5147 136.375 67.9358C136.375 68.3569 136.033 68.6983 135.612 68.6983H101.3C100.878 68.6983 100.537 68.3569 100.537 67.9358Z"
			fill="#58707F"
		/>
		<path
			d="M105.875 71.7483C105.875 71.3272 106.216 70.9858 106.637 70.9858H130.275C130.696 70.9858 131.037 71.3272 131.037 71.7483C131.037 72.1694 130.696 72.5108 130.275 72.5108H106.637C106.216 72.5108 105.875 72.1694 105.875 71.7483Z"
			fill="#58707F"
		/>
		<path
			d="M99.0121 75.5608C99.0121 75.1397 99.3535 74.7983 99.7746 74.7983H137.137C137.558 74.7983 137.9 75.1397 137.9 75.5608C137.9 75.9819 137.558 76.3233 137.137 76.3233H99.7746C99.3535 76.3233 99.0121 75.9819 99.0121 75.5608Z"
			fill="#58707F"
		/>
		<path
			d="M103.968 79.3733C103.968 78.9522 104.31 78.6108 104.731 78.6108H132.181C132.602 78.6108 132.943 78.9522 132.943 79.3733C132.943 79.7944 132.602 80.1358 132.181 80.1358H104.731C104.31 80.1358 103.968 79.7944 103.968 79.3733Z"
			fill="#58707F"
		/>
		<path
			d="M107.781 83.1858C107.781 82.7647 108.122 82.4233 108.543 82.4233H128.368C128.789 82.4233 129.131 82.7647 129.131 83.1858C129.131 83.6069 128.789 83.9483 128.368 83.9483H108.543C108.122 83.9483 107.781 83.6069 107.781 83.1858Z"
			fill="#58707F"
		/>
		<path
			d="M106.256 86.9983C106.256 86.5772 106.597 86.2358 107.018 86.2358H129.893C130.314 86.2358 130.656 86.5772 130.656 86.9983C130.656 87.4194 130.314 87.7608 129.893 87.7608H107.018C106.597 87.7608 106.256 87.4194 106.256 86.9983Z"
			fill="#58707F"
		/>
		<path
			d="M106.256 90.8108C106.256 90.3897 106.597 90.0483 107.018 90.0483H129.893C130.314 90.0483 130.656 90.3897 130.656 90.8108C130.656 91.2319 130.314 91.5733 129.893 91.5733H107.018C106.597 91.5733 106.256 91.2319 106.256 90.8108Z"
			fill="#58707F"
		/>
		<path
			d="M113.396 42.5061H114.488C114.676 42.5259 114.864 42.4962 115.041 42.4189C115.217 42.3416 115.377 42.2187 115.509 42.0593C115.739 41.7083 115.854 41.2696 115.831 40.8253C115.846 40.4084 115.731 39.9996 115.509 39.6765C115.382 39.5282 115.231 39.4135 115.064 39.3402C114.897 39.2669 114.719 39.2365 114.542 39.251C114.208 39.2413 113.883 39.3777 113.629 39.634C113.512 39.7649 113.42 39.9235 113.359 40.0994C113.297 40.2753 113.267 40.4647 113.271 40.6551H111.391C111.372 40.2168 111.441 39.7792 111.594 39.3794C111.747 38.9796 111.978 38.6292 112.268 38.3575C112.896 37.7408 113.692 37.4157 114.506 37.4428C115.37 37.3862 116.223 37.7036 116.905 38.3363C117.193 38.6458 117.418 39.0286 117.564 39.4559C117.709 39.8832 117.772 40.344 117.747 40.8041C117.746 41.3299 117.608 41.8425 117.353 42.272C117.08 42.7468 116.702 43.1224 116.261 43.357C116.756 43.5507 117.183 43.9319 117.478 44.442C117.767 44.9345 117.917 45.5227 117.908 46.1226C117.929 46.6119 117.853 47.1002 117.685 47.5476C117.517 47.995 117.262 48.3888 116.941 48.6968C116.235 49.3423 115.361 49.6735 114.47 49.633C113.645 49.6651 112.835 49.3569 112.178 48.7607C111.858 48.4738 111.605 48.0947 111.442 47.6593C111.279 47.2238 111.212 46.7463 111.248 46.2716H113.038C113.032 46.4821 113.064 46.6918 113.132 46.8864C113.2 47.0809 113.302 47.2558 113.432 47.3992C113.704 47.6984 114.064 47.8588 114.435 47.846C114.628 47.8607 114.823 47.8267 115.005 47.746C115.187 47.6653 115.353 47.5399 115.491 47.3779C115.627 47.2175 115.732 47.0243 115.8 46.8116C115.868 46.5988 115.897 46.3711 115.885 46.144C115.918 45.8994 115.902 45.649 115.839 45.413C115.775 45.1771 115.666 44.9622 115.519 44.786C115.373 44.6098 115.193 44.4772 114.995 44.399C114.798 44.3206 114.587 44.2989 114.381 44.3356H113.289L113.396 42.5061Z"
			fill="#58707F"
		/>
		<path
			d="M125.804 49.4629H119.233V47.9099L122.348 43.7826C122.715 43.2839 123.039 42.7422 123.315 42.1658C123.488 41.7931 123.586 41.3781 123.601 40.9532C123.612 40.5073 123.492 40.0709 123.261 39.7193C123.148 39.5592 123.005 39.4333 122.843 39.352C122.681 39.2707 122.505 39.2361 122.33 39.2512C122.135 39.2337 121.938 39.2754 121.76 39.3721C121.582 39.4687 121.427 39.6174 121.31 39.8043C121.073 40.2488 120.954 40.7677 120.969 41.2936H119.089C119.069 40.7941 119.135 40.2951 119.283 39.8269C119.431 39.3587 119.657 38.9311 119.949 38.5704C120.259 38.1919 120.633 37.8958 121.047 37.7016C121.46 37.5072 121.904 37.419 122.348 37.4428C123.205 37.3845 124.047 37.7283 124.694 38.4002C124.979 38.7299 125.201 39.1283 125.347 39.5687C125.492 40.0088 125.556 40.481 125.535 40.9532C125.546 41.6526 125.384 42.3405 125.07 42.9317C124.589 43.7785 124.056 44.582 123.476 45.3357L121.686 47.6333H125.804V49.4629Z"
			fill="#58707F"
		/>
		<path
			d="M127.159 38.3528C127.149 38.1144 127.212 37.8799 127.338 37.6933C127.403 37.6082 127.483 37.5411 127.573 37.497C127.663 37.4528 127.759 37.4328 127.856 37.438C127.956 37.431 128.056 37.4504 128.149 37.4945C128.241 37.5386 128.325 37.6064 128.393 37.6933C128.518 37.8799 128.582 38.1144 128.572 38.3528C128.584 38.5915 128.52 38.8267 128.393 39.0123C128.328 39.0974 128.247 39.1645 128.158 39.2086C128.068 39.2528 127.971 39.2728 127.874 39.2676C127.775 39.2746 127.675 39.2554 127.582 39.2112C127.489 39.1671 127.406 39.0992 127.338 39.0123C127.211 38.8267 127.147 38.5915 127.159 38.3528ZM127.552 38.3528C127.528 38.4787 127.528 38.6098 127.552 38.7357C127.578 38.7856 127.616 38.8258 127.66 38.8521C127.704 38.8784 127.753 38.8897 127.803 38.8847C127.847 38.8894 127.892 38.8777 127.93 38.8509C127.968 38.8242 127.999 38.7839 128.017 38.7357C128.081 38.6227 128.112 38.4885 128.107 38.3528C128.109 38.2431 128.091 38.134 128.053 38.0337C128.032 37.9838 127.998 37.9427 127.956 37.9162C127.915 37.8896 127.867 37.8786 127.821 37.8847C127.776 37.88 127.732 37.8919 127.693 37.9186C127.655 37.9452 127.624 37.9855 127.606 38.0337C127.547 38.1494 127.516 38.2818 127.516 38.4166L127.552 38.3528Z"
			fill="#58707F"
		/>
		<path
			d="M131.992 40.2034C132.001 40.3991 131.975 40.5949 131.917 40.7781C131.858 40.9613 131.768 41.1279 131.652 41.2671C131.374 41.5345 131.024 41.6709 130.667 41.6502C130.477 41.6647 130.287 41.6282 130.11 41.5434C129.933 41.4588 129.775 41.328 129.646 41.1608C129.513 40.9981 129.41 40.8046 129.342 40.5924C129.274 40.3802 129.244 40.1536 129.253 39.9268V39.1185C129.236 38.6643 129.371 38.2208 129.629 37.8846C129.906 37.5958 130.262 37.4366 130.631 37.4366C131 37.4366 131.356 37.5958 131.634 37.8846C131.757 38.0185 131.853 38.1836 131.915 38.3678C131.977 38.552 132.003 38.7503 131.992 38.9483H131.312C131.324 38.7195 131.267 38.493 131.151 38.31C131.081 38.2337 130.999 38.1753 130.91 38.1386C130.82 38.102 130.725 38.0879 130.631 38.0973C130.543 38.1132 130.459 38.1518 130.385 38.2106C130.31 38.2695 130.248 38.347 130.202 38.4377C130.073 38.671 130.011 38.9466 130.023 39.2249V40.0332C130.008 40.3151 130.077 40.594 130.219 40.8204C130.281 40.9146 130.359 40.9904 130.449 41.0421C130.54 41.0938 130.639 41.1198 130.739 41.1182C130.828 41.1285 130.917 41.1146 131.001 41.0778C131.085 41.041 131.16 40.982 131.222 40.9055C131.342 40.733 131.4 40.5113 131.383 40.2886L131.992 40.2034Z"
			fill="#58707F"
		/>
		<path
			d="M133.35 37.7752C133.35 37.588 133.502 37.4363 133.689 37.4363C133.876 37.4363 134.028 37.588 134.028 37.7752V41.3141C134.028 41.5013 133.876 41.653 133.689 41.653C133.502 41.653 133.35 41.5013 133.35 41.3141V37.7752Z"
			fill="#9FA9AF"
		/>
		<path
			d="M135.385 38.3518C135.375 38.1137 135.439 37.8795 135.564 37.6932C135.629 37.6081 135.71 37.5412 135.799 37.4972C135.889 37.4531 135.986 37.433 136.082 37.4382C136.182 37.4313 136.282 37.4505 136.375 37.4946C136.467 37.5387 136.551 37.6065 136.619 37.6932C136.744 37.8795 136.808 38.1137 136.798 38.3518C136.81 38.5902 136.746 38.8252 136.619 39.0105C136.554 39.0956 136.473 39.1625 136.384 39.2065C136.294 39.2506 136.197 39.2707 136.1 39.2655C136.001 39.2724 135.901 39.2532 135.808 39.2091C135.715 39.165 135.632 39.0972 135.564 39.0105C135.437 38.8252 135.373 38.5902 135.385 38.3518ZM135.778 38.3518C135.754 38.4777 135.754 38.6085 135.778 38.7343C135.805 38.7841 135.842 38.8243 135.886 38.8505C135.93 38.8768 135.98 38.888 136.029 38.883C136.073 38.8877 136.118 38.8759 136.156 38.8493C136.195 38.8227 136.225 38.7825 136.243 38.7343C136.307 38.6214 136.338 38.4874 136.333 38.3518C136.335 38.2422 136.317 38.1334 136.279 38.0331C136.258 37.9833 136.224 37.9423 136.182 37.9158C136.141 37.8892 136.094 37.8783 136.047 37.8844C136.002 37.8797 135.958 37.8915 135.919 37.9181C135.881 37.9448 135.85 37.985 135.832 38.0331C135.774 38.1486 135.743 38.2808 135.743 38.4156L135.778 38.3518Z"
			fill="#9FA9AF"
		/>
		<path
			d="M139.714 39.9031H138.347V41.6526H137.663V37.4368H140.021V38.0903H138.347V39.2496H139.782L139.714 39.9031Z"
			fill="#9FA9AF"
		/>
		<path
			d="M108.575 47.1306C108.575 47.8904 108.273 48.6189 107.736 49.1564C107.199 49.6939 106.47 49.9963 105.711 49.9975H98.3591C97.5022 49.9757 96.6876 49.6201 96.0892 49.0063C95.4907 48.3925 95.1558 47.5691 95.1558 46.7118C95.1558 45.8546 95.4907 45.0312 96.0892 44.4173C96.6876 43.8035 97.5022 43.4478 98.3591 43.4261H98.4499C98.6023 42.815 98.9358 42.2643 99.4065 41.8459C99.8773 41.4276 100.463 41.1611 101.088 41.0816C101.713 41.002 102.347 41.113 102.908 41.4C103.468 41.6869 103.929 42.1365 104.23 42.6899C104.385 42.6536 104.545 42.6352 104.704 42.635C105.213 42.6376 105.702 42.8258 106.081 43.1642C106.461 43.5025 106.703 43.9678 106.763 44.4724C107.296 44.6841 107.753 45.0503 108.076 45.524C108.399 45.9977 108.573 46.5573 108.575 47.1306Z"
			fill="#58707F"
		/>
	</svg>
);
// preset images.
export const VerticalCardPresetOne = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 90 : 76 }
		height={ isPopup ? 148 : 125 }
		fill="none"
		viewBox="0 0 76 125"
	>
		<rect
			width={ 74.733 }
			height={ 123.733 }
			x={ 0.633 }
			y={ 0.633 }
			fill="#fff"
			rx={ 1.9 }
		/>
		<rect
			width={ 74.733 }
			height={ 123.733 }
			x={ 0.633 }
			y={ 0.633 }
			stroke="#8796A1"
			strokeWidth={ 1.267 }
			rx={ 1.9 }
		/>
		<rect
			width={ 66.5 }
			height={ 116.192 }
			x={ 4.75 }
			y={ 3.904 }
			fill="#fff"
			stroke="#58707F"
			strokeWidth={ 0.731 }
			rx={ 1.827 }
		/>
		<rect
			width={ 32.154 }
			height={ 2.923 }
			x={ 21.192 }
			y={ 10.962 }
			fill="#58707F"
			rx={ 1.462 }
		/>
		<rect
			width={ 10.231 }
			height={ 1.462 }
			x={ 24.48 }
			y={ 15.347 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 14.615 }
			height={ 1.462 }
			x={ 35.442 }
			y={ 15.347 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<path
			fill="#58707F"
			d="M11.693 80.385a1.462 1.462 0 1 1-2.924 0 1.462 1.462 0 0 1 2.924 0Z"
		/>
		<rect
			width={ 7.308 }
			height={ 1.462 }
			x={ 12.423 }
			y={ 79.654 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<path
			fill="#58707F"
			d="M29.596 80.385a1.462 1.462 0 1 1-2.923 0 1.462 1.462 0 0 1 2.923 0Z"
		/>
		<rect
			width={ 11.692 }
			height={ 1.462 }
			x={ 30.327 }
			y={ 79.654 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<path
			fill="#58707F"
			d="M51.885 80.385a1.462 1.462 0 1 1-2.923 0 1.462 1.462 0 0 1 2.923 0Z"
		/>
		<rect
			width={ 14.615 }
			height={ 1.462 }
			x={ 52.616 }
			y={ 79.654 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 17.538 }
			height={ 2.192 }
			x={ 8.77 }
			y={ 87.692 }
			fill="#58707F"
			rx={ 1.096 }
		/>
		<rect
			width={ 14.615 }
			height={ 2.192 }
			x={ 52.616 }
			y={ 87.692 }
			fill="#58707F"
			rx={ 1.096 }
		/>
		<rect
			width={ 8.769 }
			height={ 1.462 }
			x={ 8.77 }
			y={ 94.269 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<path
			fill="#58707F"
			d="M39.462 95a2.192 2.192 0 1 1-4.385 0 2.192 2.192 0 0 1 4.385 0Z"
		/>
		<rect
			width={ 5.846 }
			height={ 1.462 }
			x={ 54.077 }
			y={ 94.269 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 5.846 }
			height={ 1.462 }
			x={ 61.385 }
			y={ 94.269 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 11.692 }
			height={ 1.462 }
			x={ 8.77 }
			y={ 100.847 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<path
			fill="#58707F"
			d="M39.462 101.577a2.192 2.192 0 1 1-4.384 0 2.192 2.192 0 0 1 4.384 0Z"
		/>
		<rect
			width={ 5.846 }
			height={ 1.462 }
			x={ 54.077 }
			y={ 100.847 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 5.846 }
			height={ 1.462 }
			x={ 61.385 }
			y={ 100.847 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 10.231 }
			height={ 1.462 }
			x={ 8.77 }
			y={ 107.424 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<path
			fill="#58707F"
			d="M39.462 108.154a2.193 2.193 0 1 1-4.386 0 2.193 2.193 0 0 1 4.386 0Z"
		/>
		<rect
			width={ 5.846 }
			height={ 1.462 }
			x={ 54.077 }
			y={ 107.424 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 5.846 }
			height={ 1.462 }
			x={ 61.385 }
			y={ 107.424 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 10.231 }
			height={ 1.462 }
			x={ 8.77 }
			y={ 114 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<path
			fill="#58707F"
			d="M39.462 114.73a2.193 2.193 0 1 1-4.386 0 2.193 2.193 0 0 1 4.386 0Z"
		/>
		<rect
			width={ 5.846 }
			height={ 1.462 }
			x={ 54.077 }
			y={ 113.999 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 5.846 }
			height={ 1.462 }
			x={ 61.385 }
			y={ 113.999 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 10.231 }
			height={ 1.462 }
			x={ 27.039 }
			y={ 40.192 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 10.231 }
			height={ 1.462 }
			x={ 39.461 }
			y={ 40.192 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 29.962 }
			height={ 1.462 }
			x={ 23.385 }
			y={ 43.847 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 34.346 }
			height={ 1.462 }
			x={ 21.192 }
			y={ 51.154 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 24.115 }
			height={ 1.462 }
			x={ 26.308 }
			y={ 54.809 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 37.269 }
			height={ 1.462 }
			x={ 19.73 }
			y={ 58.462 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 27.769 }
			height={ 1.462 }
			x={ 24.48 }
			y={ 62.116 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 20.462 }
			height={ 1.462 }
			x={ 28.134 }
			y={ 65.769 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 23.385 }
			height={ 1.462 }
			x={ 26.673 }
			y={ 69.424 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<rect
			width={ 23.385 }
			height={ 1.462 }
			x={ 26.673 }
			y={ 73.077 }
			fill="#58707F"
			rx={ 0.731 }
		/>
		<path
			fill="#58707F"
			d="M33.97 27.518h1.047c.18.019.36-.01.53-.084.169-.074.322-.192.448-.344.22-.337.33-.757.309-1.183.014-.4-.096-.792-.309-1.101a1.196 1.196 0 0 0-.426-.323c-.16-.07-.33-.1-.5-.085-.32-.01-.632.121-.876.367-.111.125-.2.277-.259.446-.059.169-.087.35-.084.533h-1.802c-.018-.42.049-.84.195-1.223.147-.384.368-.72.646-.98.602-.591 1.364-.902 2.145-.877.828-.054 1.645.25 2.3.857.275.297.49.663.63 1.073.14.41.2.851.176 1.292 0 .504-.133.996-.377 1.408a2.667 2.667 0 0 1-1.047 1.04c.474.185.884.55 1.167 1.04.276.472.42 1.035.411 1.61a3.47 3.47 0 0 1-.214 1.366 2.974 2.974 0 0 1-.712 1.102c-.677.619-1.515.936-2.368.897-.791.031-1.568-.264-2.197-.836a2.667 2.667 0 0 1-.706-1.055 3.148 3.148 0 0 1-.186-1.33h1.716c-.006.201.025.402.09.589.065.186.163.354.288.491.26.287.605.44.96.428.186.015.373-.018.547-.095a1.32 1.32 0 0 0 .466-.353c.13-.154.231-.34.297-.543.065-.204.092-.422.08-.64a1.782 1.782 0 0 0-.044-.7 1.582 1.582 0 0 0-.306-.602 1.26 1.26 0 0 0-.502-.37 1.078 1.078 0 0 0-.589-.061h-1.047l.103-1.754ZM45.862 34.186h-6.297v-1.488l2.985-3.957a9.56 9.56 0 0 0 .927-1.55 3.04 3.04 0 0 0 .274-1.162 2.074 2.074 0 0 0-.326-1.183 1.098 1.098 0 0 0-.4-.352.916.916 0 0 0-.492-.096.962.962 0 0 0-.546.116c-.171.092-.32.235-.432.414-.227.426-.34.923-.326 1.427h-1.802c-.019-.478.044-.957.186-1.405.142-.45.358-.86.638-1.205a3.041 3.041 0 0 1 1.052-.833c.396-.186.822-.27 1.247-.248.822-.056 1.629.274 2.248.918.273.316.487.698.626 1.12.14.422.2.875.18 1.327a3.92 3.92 0 0 1-.446 1.897 19.79 19.79 0 0 1-1.527 2.304l-1.716 2.202h3.947v1.754ZM47.16 23.532a1.06 1.06 0 0 1 .172-.632.646.646 0 0 1 .226-.188.546.546 0 0 1 .271-.056.56.56 0 0 1 .28.054.66.66 0 0 1 .235.19c.12.18.18.404.171.632.011.23-.05.455-.171.632a.648.648 0 0 1-.226.189.547.547 0 0 1-.272.056.559.559 0 0 1-.28-.054.66.66 0 0 1-.234-.19 1.036 1.036 0 0 1-.172-.633Zm.378 0a.964.964 0 0 0 0 .367.28.28 0 0 0 .103.112c.042.025.09.036.137.031a.18.18 0 0 0 .122-.032.234.234 0 0 0 .084-.11.7.7 0 0 0 .085-.368.832.832 0 0 0-.051-.305.248.248 0 0 0-.093-.113.193.193 0 0 0-.13-.03.18.18 0 0 0-.122.032.235.235 0 0 0-.084.11.817.817 0 0 0-.085.368l.034-.062ZM51.793 25.306a1.58 1.58 0 0 1-.072.55 1.396 1.396 0 0 1-.254.47 1.252 1.252 0 0 1-.944.366 1.046 1.046 0 0 1-.534-.102 1.24 1.24 0 0 1-.444-.366 1.654 1.654 0 0 1-.292-.545 1.86 1.86 0 0 1-.086-.638v-.775c-.015-.435.114-.86.36-1.182.267-.277.608-.43.962-.43.353 0 .695.153.96.43.119.128.21.286.27.463.06.176.085.366.074.556h-.652a1.043 1.043 0 0 0-.155-.612.642.642 0 0 0-.23-.164.556.556 0 0 0-.267-.04.534.534 0 0 0-.237.11.658.658 0 0 0-.175.217 1.448 1.448 0 0 0-.172.754v.775c-.014.27.053.537.189.754.059.09.134.163.22.213.087.05.182.074.278.073a.483.483 0 0 0 .251-.039.568.568 0 0 0 .212-.165.923.923 0 0 0 .154-.591l.584-.082Z"
		/>
		<rect
			width={ 0.65 }
			height={ 4.041 }
			x={ 53.095 }
			y={ 22.654 }
			fill="#9FA9AF"
			rx={ 0.325 }
		/>
		<path
			fill="#9FA9AF"
			d="M55.044 23.531c-.01-.228.052-.453.172-.631a.646.646 0 0 1 .225-.188.547.547 0 0 1 .272-.056.56.56 0 0 1 .28.054.66.66 0 0 1 .234.19c.12.178.181.403.171.631.012.229-.05.454-.171.632a.646.646 0 0 1-.226.187.546.546 0 0 1-.271.057.56.56 0 0 1-.28-.054.66.66 0 0 1-.234-.19 1.035 1.035 0 0 1-.172-.632Zm.377 0a.961.961 0 0 0 0 .367c.026.047.061.086.104.111.042.025.09.036.136.031a.18.18 0 0 0 .122-.032.235.235 0 0 0 .084-.11.698.698 0 0 0 .086-.367.827.827 0 0 0-.052-.305.249.249 0 0 0-.092-.113.193.193 0 0 0-.13-.03.18.18 0 0 0-.123.033.235.235 0 0 0-.083.11.816.816 0 0 0-.086.366l.034-.06ZM59.193 25.018h-1.31v1.677h-.656v-4.04h2.26v.626h-1.604v1.11h1.375l-.065.627Z"
		/>
		<path
			fill="#58707F"
			d="M29.376 31.362a2.75 2.75 0 0 1-2.745 2.748h-7.046a3.15 3.15 0 0 1 0-6.298h.087a2.996 2.996 0 0 1 5.54-.706 1.997 1.997 0 0 1 2.428 1.708 2.754 2.754 0 0 1 1.736 2.548Z"
		/>
	</svg>
);
export const VerticalCardPresetTwo = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 90 : 76 }
		height={ isPopup ? 148 : 125 }
		fill="none"
		viewBox="0 0 76 125"
	>
		<rect
			width={ 74.733 }
			height={ 123.733 }
			x={ 0.633 }
			y={ 0.633 }
			fill="#fff"
			rx={ 1.9 }
		/>
		<rect
			width={ 74.733 }
			height={ 123.733 }
			x={ 0.633 }
			y={ 0.633 }
			stroke="#8796A1"
			strokeWidth={ 1.267 }
			rx={ 1.9 }
		/>
		<rect
			width={ 66.122 }
			height={ 115.532 }
			x={ 4.94 }
			y={ 4.234 }
			fill="#fff"
			stroke="#58707F"
			strokeWidth={ 0.727 }
			rx={ 1.817 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 13.08 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 52.533 }
			y={ 13.08 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 26.012 }
			y={ 45.051 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 0.727 }
			height={ 1.453 }
			x={ 37.638 }
			y={ 45.051 }
			fill="#58707F"
			rx={ 0.363 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 39.818 }
			y={ 45.051 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 34.877 }
			height={ 1.453 }
			x={ 20.563 }
			y={ 48.684 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 31.971 }
			height={ 2.906 }
			x={ 22.015 }
			y={ 21.799 }
			fill="#58707F"
			rx={ 1.453 }
		/>
		<path
			fill="#58707F"
			d="M38.018 33.902h1.04c.179.02.358-.01.526-.083.168-.074.32-.19.446-.343.22-.334.328-.752.307-1.176a1.83 1.83 0 0 0-.307-1.094 1.19 1.19 0 0 0-.424-.321 1.022 1.022 0 0 0-.497-.085c-.317-.01-.627.12-.869.365a1.326 1.326 0 0 0-.257.444 1.516 1.516 0 0 0-.084.53h-1.79a3.05 3.05 0 0 1 .194-1.217 2.6 2.6 0 0 1 .641-.974c.598-.588 1.356-.897 2.131-.872.823-.053 1.635.249 2.285.852.273.295.488.66.626 1.067.14.407.199.847.175 1.285 0 .501-.132.99-.375 1.4-.26.452-.62.81-1.04 1.033.471.185.878.548 1.16 1.034.274.47.417 1.03.408 1.602.02.467-.052.932-.212 1.358-.16.427-.403.802-.708 1.096-.673.615-1.505.93-2.353.892-.786.03-1.557-.263-2.182-.831a2.652 2.652 0 0 1-.701-1.05 3.132 3.132 0 0 1-.185-1.323h1.704c-.006.2.025.4.09.586.064.186.162.352.285.489.26.285.602.438.955.426.185.014.37-.018.543-.095a1.31 1.31 0 0 0 .463-.351c.13-.153.23-.337.294-.54.065-.203.093-.42.081-.636a1.773 1.773 0 0 0-.044-.697 1.575 1.575 0 0 0-.304-.598 1.252 1.252 0 0 0-.499-.369 1.07 1.07 0 0 0-.585-.06h-1.04l.102-1.744ZM49.832 40.533h-6.257v-1.48l2.967-3.934c.35-.475.658-.992.92-1.541.165-.355.258-.75.273-1.156.01-.425-.104-.84-.324-1.176a1.09 1.09 0 0 0-.398-.35.909.909 0 0 0-.488-.096.956.956 0 0 0-.543.115 1.17 1.17 0 0 0-.43.412 2.86 2.86 0 0 0-.323 1.42h-1.79a4.116 4.116 0 0 1 .184-1.398c.141-.447.357-.854.634-1.198a3.02 3.02 0 0 1 1.046-.828c.393-.185.816-.27 1.239-.247.816-.055 1.618.273 2.233.913.271.314.483.694.622 1.113.138.42.199.87.18 1.32a3.902 3.902 0 0 1-.444 1.886 19.666 19.666 0 0 1-1.517 2.291l-1.705 2.19h3.92v1.744ZM50.832 29.938c-.01-.228.05-.451.17-.629a.644.644 0 0 1 .225-.187.542.542 0 0 1 .27-.056.557.557 0 0 1 .278.054.657.657 0 0 1 .233.19c.12.177.18.4.17.628.012.227-.049.451-.17.628a.645.645 0 0 1-.224.187.542.542 0 0 1-.27.056.557.557 0 0 1-.279-.053.657.657 0 0 1-.233-.19c-.12-.177-.181-.4-.17-.628Zm.375 0a.957.957 0 0 0 0 .364c.025.048.06.086.102.111.043.025.09.036.137.031a.178.178 0 0 0 .12-.032.233.233 0 0 0 .084-.11.696.696 0 0 0 .085-.364.827.827 0 0 0-.05-.304.247.247 0 0 0-.093-.113.192.192 0 0 0-.13-.03.179.179 0 0 0-.12.033.233.233 0 0 0-.084.11.812.812 0 0 0-.085.364l.034-.06ZM55.438 31.701c.009.187-.016.373-.072.548a1.388 1.388 0 0 1-.252.466 1.246 1.246 0 0 1-.938.365 1.04 1.04 0 0 1-.532-.102 1.233 1.233 0 0 1-.441-.365 1.642 1.642 0 0 1-.29-.541 1.85 1.85 0 0 1-.085-.635v-.77a1.835 1.835 0 0 1 .358-1.176c.264-.275.604-.427.955-.427.352 0 .691.152.956.427.117.128.209.285.268.46.059.176.084.365.073.554h-.648a1.037 1.037 0 0 0-.154-.608.64.64 0 0 0-.23-.164.553.553 0 0 0-.265-.039.53.53 0 0 0-.235.108.656.656 0 0 0-.174.216 1.44 1.44 0 0 0-.17.75v.77a1.29 1.29 0 0 0 .187.751.65.65 0 0 0 .22.211c.085.05.18.074.275.073.084.01.17-.004.25-.039a.566.566 0 0 0 .21-.164.918.918 0 0 0 .154-.588l.58-.08Z"
		/>
		<path
			fill="#9FA9AF"
			d="M50.832 37.37c-.01-.227.051-.45.17-.628a.644.644 0 0 1 .225-.186.543.543 0 0 1 .27-.057.555.555 0 0 1 .278.054.657.657 0 0 1 .233.19c.12.177.18.4.17.627.012.227-.05.451-.17.628a.643.643 0 0 1-.225.187.544.544 0 0 1-.27.056.557.557 0 0 1-.278-.054.657.657 0 0 1-.233-.19c-.12-.176-.181-.4-.17-.627Zm.375 0a.959.959 0 0 0 0 .364c.025.048.06.086.102.111.042.025.09.036.136.031a.18.18 0 0 0 .122-.032.233.233 0 0 0 .083-.11.695.695 0 0 0 .085-.364.825.825 0 0 0-.051-.304.247.247 0 0 0-.092-.112.192.192 0 0 0-.13-.03.179.179 0 0 0-.12.033.233.233 0 0 0-.084.11.811.811 0 0 0-.085.364l.034-.061ZM54.956 38.848h-1.302v1.667h-.652v-4.017h2.247v.623h-1.595v1.104h1.367l-.065.623Z"
		/>
		<path
			fill="#58707F"
			d="M33.35 37.723a2.735 2.735 0 0 1-2.73 2.732h-7.005a3.132 3.132 0 0 1 0-6.262h.087a2.979 2.979 0 0 1 5.507-.702 1.986 1.986 0 0 1 2.414 1.699 2.738 2.738 0 0 1 1.727 2.533Z"
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 82.108 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 85.741 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 58.346 }
			y={ 82.108 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 56.167 }
			y={ 85.741 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 17.439 }
			height={ 2.18 }
			x={ 8.937 }
			y={ 94.461 }
			fill="#58707F"
			rx={ 1.09 }
		/>
		<rect
			width={ 14.532 }
			height={ 2.18 }
			x={ 52.533 }
			y={ 94.461 }
			fill="#58707F"
			rx={ 1.09 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 10.39 }
			y={ 101 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M17.656 106.449a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 10.026 }
			y={ 110.446 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.079 }
			height={ 1.453 }
			x={ 23.953 }
			y={ 101 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M32.673 106.449a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 25.043 }
			y={ 110.446 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.079 }
			height={ 1.453 }
			x={ 38.97 }
			y={ 101 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M47.689 106.449a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 40.06 }
			y={ 110.446 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 54.713 }
			y={ 101 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M62.706 106.449a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 55.077 }
			y={ 110.446 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 11.843 }
			y={ 57.403 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 10.39 }
			y={ 61.036 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.079 }
			height={ 1.453 }
			x={ 31.461 }
			y={ 57.403 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 30.735 }
			y={ 61.036 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.079 }
			height={ 1.453 }
			x={ 53.26 }
			y={ 57.403 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 54.35 }
			y={ 61.036 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<circle cx={ 23.469 } cy={ 85.741 } r={ 1.453 } fill="#58707F" />
		<circle cx={ 52.533 } cy={ 85.741 } r={ 1.453 } fill="#58707F" />
		<path
			fill="#58707F"
			d="M52.65 85.015a.592.592 0 0 0 .598-.61 15.26 15.26 0 0 0-29.344-5.23 15.26 15.26 0 0 0-1.15 5.23.592.592 0 0 0 .598.61.632.632 0 0 0 .624-.61 14.036 14.036 0 0 1 14.025-13.428 14.038 14.038 0 0 1 14.025 13.428c.015.336.287.61.624.61Z"
		/>
		<g fill="#58707F" clipPath="url(#a)">
			<path d="M35.363 68.504a.464.464 0 0 0 .66 0 .466.466 0 0 0 0-.66l-.66-.659a.466.466 0 1 0-.659.66l.66.659ZM35.204 70.483c0-.258-.209-.424-.466-.424h-.933c-.258 0-.466.166-.466.424 0 .257.208.423.466.423h.933c.257 0 .466-.166.466-.424ZM38.001 67.684c.258 0 .424-.208.424-.466v-.932c0-.258-.166-.467-.424-.467s-.424.21-.424.467v.932c0 .258.166.466.424.466ZM40.309 68.64c.12 0 .239-.045.33-.136l.659-.66a.466.466 0 1 0-.66-.659l-.659.66a.466.466 0 0 0 .33.796ZM38.001 68.151a2.334 2.334 0 0 0-2.331 2.332A2.334 2.334 0 0 0 38 72.813a2.334 2.334 0 0 0 2.331-2.33 2.334 2.334 0 0 0-2.33-2.332ZM35.363 72.46l-.659.66a.466.466 0 1 0 .66.658l.659-.659a.466.466 0 1 0-.66-.66ZM40.639 72.46a.466.466 0 1 0-.66.66l.66.658a.464.464 0 0 0 .659 0 .466.466 0 0 0 0-.659l-.66-.66ZM42.197 70.059h-.932c-.258 0-.467.166-.467.424 0 .257.209.423.467.423h.932c.258 0 .466-.166.466-.424 0-.257-.208-.423-.466-.423ZM38.001 73.28c-.258 0-.424.208-.424.466v.932c0 .258.166.466.424.466s.424-.209.424-.466v-.932c0-.258-.166-.467-.424-.467Z" />
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M32.915 65.395h10.173V75.57H32.915z" />
			</clipPath>
		</defs>
	</svg>
);
export const VerticalCardPresetThree = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 90 : 76 }
		height={ isPopup ? 148 : 125 }
		fill="none"
		viewBox="0 0 76 125"
	>
		<rect
			width={ 74.733 }
			height={ 123.733 }
			x={ 0.633 }
			y={ 0.633 }
			fill="#fff"
			rx={ 1.9 }
		/>
		<rect
			width={ 74.733 }
			height={ 123.733 }
			x={ 0.633 }
			y={ 0.633 }
			stroke="#8796A1"
			strokeWidth={ 1.267 }
			rx={ 1.9 }
		/>
		<rect
			width={ 66.122 }
			height={ 115.532 }
			x={ 4.94 }
			y={ 4.234 }
			fill="#fff"
			stroke="#58707F"
			strokeWidth={ 0.727 }
			rx={ 1.817 }
		/>
		<path
			fill="#58707F"
			d="M12.57 10.536a1.817 1.817 0 1 1-3.633 0 1.817 1.817 0 0 1 3.633 0Z"
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 13.296 }
			y={ 9.81 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 56.893 }
			y={ 9.81 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 17.439 }
			height={ 2.18 }
			x={ 8.937 }
			y={ 69.051 }
			fill="#58707F"
			rx={ 1.09 }
		/>
		<rect
			width={ 14.532 }
			height={ 2.18 }
			x={ 52.533 }
			y={ 69.051 }
			fill="#58707F"
			rx={ 1.09 }
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 75.59 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M39.454 76.317a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 53.987 }
			y={ 75.59 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 61.253 }
			y={ 75.59 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 81.888 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M39.454 82.614a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 53.987 }
			y={ 81.888 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 61.253 }
			y={ 81.888 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 88.185 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M39.454 88.911a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 53.987 }
			y={ 88.185 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 61.253 }
			y={ 88.185 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 94.481 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M39.454 95.208a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 53.987 }
			y={ 94.481 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 61.253 }
			y={ 94.481 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 100.779 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M39.454 101.506a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 53.987 }
			y={ 100.779 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 61.253 }
			y={ 100.779 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 107.076 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M39.454 107.803a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 53.987 }
			y={ 107.076 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 61.253 }
			y={ 107.076 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 113.374 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M39.454 114.101a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 53.987 }
			y={ 113.374 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 61.253 }
			y={ 113.374 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 15.259 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 39.964 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 9.446 }
			height={ 1.453 }
			x={ 25.648 }
			y={ 39.964 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 9.446 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 43.597 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 19.836 }
			y={ 43.597 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.806 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 47.23 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 24.195 }
			y={ 47.23 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 15.986 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 50.863 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 26.375 }
			y={ 50.863 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.079 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 54.496 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 23.469 }
			y={ 54.496 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 58.129 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 9.446 }
			height={ 1.453 }
			x={ 21.289 }
			y={ 58.129 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 61.763 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 22.016 }
			y={ 61.763 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 41.752 }
			y={ 39.964 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 57.737 }
			y={ 39.964 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.806 }
			height={ 1.453 }
			x={ 45.385 }
			y={ 43.597 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 60.644 }
			y={ 43.597 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 16.712 }
			height={ 1.453 }
			x={ 41.752 }
			y={ 47.23 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.993 }
			height={ 1.453 }
			x={ 59.917 }
			y={ 47.23 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 46.112 }
			y={ 50.863 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 62.097 }
			y={ 50.863 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.079 }
			height={ 1.453 }
			x={ 48.291 }
			y={ 54.496 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.086 }
			height={ 1.453 }
			x={ 62.824 }
			y={ 54.496 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 51.198 }
			y={ 58.129 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 6.54 }
			height={ 1.453 }
			x={ 61.371 }
			y={ 58.129 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 46.112 }
			y={ 61.763 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 59.191 }
			y={ 61.763 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 17.439 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 32.697 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.079 }
			height={ 1.453 }
			x={ 53.987 }
			y={ 32.697 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 51.198 }
			y={ 28.338 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 60.644 }
			y={ 28.338 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M26.441 23.001h1.047c.18.019.36-.01.53-.083.169-.074.322-.19.448-.343.22-.334.33-.753.31-1.176a1.82 1.82 0 0 0-.31-1.095 1.196 1.196 0 0 0-.426-.32c-.16-.07-.33-.1-.5-.086-.32-.009-.631.121-.875.366-.112.124-.2.276-.26.443a1.51 1.51 0 0 0-.084.53H24.52a3.032 3.032 0 0 1 .194-1.216c.147-.381.368-.715.646-.974.602-.588 1.365-.898 2.145-.872.829-.054 1.646.249 2.3.852.275.295.49.66.63 1.067.14.407.2.846.176 1.285 0 .501-.132.99-.377 1.399-.262.452-.624.81-1.047 1.034.474.185.884.548 1.167 1.034.276.47.42 1.03.412 1.602.02.466-.053.932-.214 1.358a2.955 2.955 0 0 1-.713 1.095c-.677.616-1.515.931-2.368.893-.791.03-1.567-.264-2.196-.832a2.65 2.65 0 0 1-.706-1.05 3.113 3.113 0 0 1-.187-1.322h1.716c-.006.2.025.4.09.586.065.185.163.352.288.489.26.285.606.438.96.425.186.015.373-.018.547-.095.175-.077.334-.196.466-.35.13-.154.232-.338.297-.54.065-.203.092-.42.08-.637a1.76 1.76 0 0 0-.043-.697 1.572 1.572 0 0 0-.307-.597 1.26 1.26 0 0 0-.502-.369 1.084 1.084 0 0 0-.589-.06H26.34L26.44 23ZM38.38 29.797H31.99v-1.502l3.03-3.99a9.636 9.636 0 0 0 .94-1.564c.167-.36.262-.761.278-1.172a2.083 2.083 0 0 0-.331-1.193 1.112 1.112 0 0 0-.407-.355.934.934 0 0 0-.498-.098.98.98 0 0 0-.554.117 1.19 1.19 0 0 0-.438.418c-.23.43-.346.932-.331 1.44h-1.828c-.02-.483.045-.965.188-1.418.144-.453.364-.866.648-1.215a3.082 3.082 0 0 1 1.067-.84 2.645 2.645 0 0 1 1.265-.25c.833-.056 1.652.276 2.28.926.278.319.494.704.635 1.13.141.425.204.882.184 1.338a3.936 3.936 0 0 1-.453 1.913 19.946 19.946 0 0 1-1.55 2.324l-1.74 2.222h4.004v1.769ZM39.407 19.038c-.009-.227.052-.45.171-.628a.643.643 0 0 1 .224-.187.542.542 0 0 1 .27-.057.556.556 0 0 1 .279.054.657.657 0 0 1 .233.19c.12.177.18.401.17.628.012.228-.05.452-.17.629a.645.645 0 0 1-.225.187.544.544 0 0 1-.27.056.557.557 0 0 1-.278-.054.657.657 0 0 1-.233-.19 1.031 1.031 0 0 1-.17-.628Zm.376 0a.957.957 0 0 0 0 .365c.025.048.06.086.102.11.042.026.09.037.136.032a.178.178 0 0 0 .122-.032.233.233 0 0 0 .083-.11.696.696 0 0 0 .085-.365.828.828 0 0 0-.051-.304.247.247 0 0 0-.092-.112.192.192 0 0 0-.13-.03.179.179 0 0 0-.12.032.233.233 0 0 0-.084.11.812.812 0 0 0-.085.365l.034-.06ZM44.014 20.802a1.57 1.57 0 0 1-.072.547 1.39 1.39 0 0 1-.252.466 1.246 1.246 0 0 1-.939.365 1.04 1.04 0 0 1-.53-.101 1.233 1.233 0 0 1-.442-.365 1.642 1.642 0 0 1-.29-.542 1.85 1.85 0 0 1-.086-.634v-.77a1.835 1.835 0 0 1 .359-1.176c.264-.275.604-.427.955-.427.352 0 .691.152.956.427.117.128.209.285.268.46.059.176.084.365.073.554h-.649a1.037 1.037 0 0 0-.153-.609.64.64 0 0 0-.23-.163.552.552 0 0 0-.265-.04.53.53 0 0 0-.235.109.654.654 0 0 0-.174.216 1.44 1.44 0 0 0-.171.75v.77c-.014.27.052.535.188.75a.65.65 0 0 0 .219.212c.086.05.18.074.275.072a.48.48 0 0 0 .25-.038.565.565 0 0 0 .211-.164.918.918 0 0 0 .154-.588l.58-.081Z"
		/>
		<path
			fill="#9FA9AF"
			d="M39.408 26.365c-.01-.227.05-.45.17-.628a.642.642 0 0 1 .224-.186.543.543 0 0 1 .27-.056.557.557 0 0 1 .279.053.656.656 0 0 1 .233.19c.119.177.18.4.17.627a1.03 1.03 0 0 1-.17.628.643.643 0 0 1-.225.187.543.543 0 0 1-.27.056.557.557 0 0 1-.278-.054.656.656 0 0 1-.233-.19c-.12-.176-.182-.4-.17-.627Zm.374 0a.959.959 0 0 0 0 .365c.025.047.06.085.103.11.042.025.09.036.136.031a.179.179 0 0 0 .121-.032.234.234 0 0 0 .084-.11.694.694 0 0 0 .085-.364.825.825 0 0 0-.051-.304.249.249 0 0 0-.093-.111.192.192 0 0 0-.129-.03.179.179 0 0 0-.121.032.233.233 0 0 0-.083.11.813.813 0 0 0-.086.364l.035-.06ZM43.532 27.843h-1.303v1.668h-.65v-4.018h2.246v.623H42.23v1.105h1.368l-.065.622Z"
		/>
		<path
			fill="#58707F"
			d="M21.724 27.077a2.734 2.734 0 0 1-2.73 2.732H11.99a3.132 3.132 0 0 1 0-6.262h.086a2.98 2.98 0 0 1 5.508-.701c.149-.035.3-.053.453-.053a1.986 1.986 0 0 1 1.962 1.751 2.738 2.738 0 0 1 1.726 2.533Z"
		/>
	</svg>
);
export const VerticalCardPresetFour = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 90 : 76 }
		height={ isPopup ? 148 : 125 }
		fill="none"
		viewBox="0 0 76 125"
	>
		<rect
			width={ 74.733 }
			height={ 123.733 }
			x={ 0.633 }
			y={ 0.633 }
			fill="#fff"
			rx={ 1.9 }
		/>
		<rect
			width={ 74.733 }
			height={ 123.733 }
			x={ 0.633 }
			y={ 0.633 }
			stroke="#8796A1"
			strokeWidth={ 1.267 }
			rx={ 1.9 }
		/>
		<rect
			width={ 66.122 }
			height={ 115.532 }
			x={ 4.94 }
			y={ 4.234 }
			fill="#fff"
			stroke="#58707F"
			strokeWidth={ 0.727 }
			rx={ 1.817 }
		/>
		<path
			fill="#58707F"
			d="M12.57 17.439a1.817 1.817 0 1 1-3.633 0 1.817 1.817 0 0 1 3.633 0Z"
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 13.296 }
			y={ 16.712 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 56.893 }
			y={ 16.712 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 15.259 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 77.385 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 9.446 }
			height={ 1.453 }
			x={ 25.648 }
			y={ 77.385 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 9.446 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 82.471 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 19.836 }
			y={ 82.471 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.806 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 87.558 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 24.195 }
			y={ 87.558 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 15.986 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 92.644 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 26.375 }
			y={ 92.644 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.079 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 97.731 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 23.469 }
			y={ 97.731 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 102.816 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 9.446 }
			height={ 1.453 }
			x={ 21.289 }
			y={ 102.816 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 107.902 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 22.016 }
			y={ 107.902 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 41.752 }
			y={ 77.385 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 57.737 }
			y={ 77.385 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.806 }
			height={ 1.453 }
			x={ 45.385 }
			y={ 82.471 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 60.644 }
			y={ 82.471 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 16.712 }
			height={ 1.453 }
			x={ 41.752 }
			y={ 87.558 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.993 }
			height={ 1.453 }
			x={ 59.917 }
			y={ 87.558 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 46.112 }
			y={ 92.644 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 62.097 }
			y={ 92.644 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.079 }
			height={ 1.453 }
			x={ 48.291 }
			y={ 97.731 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.086 }
			height={ 1.453 }
			x={ 62.824 }
			y={ 97.731 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 51.198 }
			y={ 102.816 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 6.54 }
			height={ 1.453 }
			x={ 61.371 }
			y={ 102.816 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 46.112 }
			y={ 107.902 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 59.191 }
			y={ 107.902 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 17.439 }
			height={ 2.18 }
			x={ 8.937 }
			y={ 51.953 }
			fill="#58707F"
			rx={ 1.09 }
		/>
		<rect
			width={ 14.532 }
			height={ 2.18 }
			x={ 52.533 }
			y={ 51.953 }
			fill="#58707F"
			rx={ 1.09 }
		/>
		<rect
			width={ 9.446 }
			height={ 1.453 }
			x={ 12.206 }
			y={ 58.492 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M19.11 63.942a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 11.479 }
			y={ 67.939 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 15.986 }
			height={ 1.453 }
			x={ 30.008 }
			y={ 58.492 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M40.181 63.942a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 32.551 }
			y={ 67.939 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 53.26 }
			y={ 58.492 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M61.253 63.942a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 53.623 }
			y={ 67.939 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<g clipPath="url(#a)">
			<path
				fill="#58707F"
				d="M67.246 65.16a.49.49 0 0 0 .837.348l1.564-1.566a.49.49 0 0 0 .144-.349v-.016a.488.488 0 0 0-.143-.363l-1.566-1.562a.49.49 0 0 0-.693.693l1.234 1.234-1.234 1.234a.49.49 0 0 0-.143.346Z"
			/>
		</g>
		<g clipPath="url(#b)">
			<path
				fill="#58707F"
				d="M8.756 65.16a.49.49 0 0 1-.837.348l-1.564-1.566a.49.49 0 0 1-.144-.349v-.016a.488.488 0 0 1 .143-.363l1.566-1.562a.49.49 0 0 1 .693.693L7.379 63.58l1.234 1.234a.49.49 0 0 1 .143.346Z"
			/>
		</g>
		<path
			fill="#58707F"
			d="M11.054 32.085h1.047c.18.019.36-.01.53-.083.169-.074.322-.19.448-.343.22-.334.33-.753.309-1.176a1.82 1.82 0 0 0-.309-1.095 1.196 1.196 0 0 0-.426-.32c-.16-.07-.33-.1-.5-.085-.32-.01-.632.12-.876.365-.111.124-.2.275-.259.443a1.51 1.51 0 0 0-.084.53H9.132a3.031 3.031 0 0 1 .195-1.216 2.6 2.6 0 0 1 .646-.974c.602-.588 1.364-.898 2.145-.872.829-.054 1.645.249 2.3.852.275.295.49.66.63 1.067.14.407.2.846.176 1.285 0 .501-.133.99-.377 1.399-.262.452-.624.81-1.047 1.034.474.185.884.548 1.167 1.034.276.47.42 1.03.411 1.602.02.466-.053.932-.214 1.358a2.956 2.956 0 0 1-.712 1.095c-.677.616-1.515.931-2.368.893-.791.03-1.567-.264-2.197-.832a2.652 2.652 0 0 1-.706-1.05 3.113 3.113 0 0 1-.186-1.322h1.716c-.006.2.025.4.09.586.065.185.163.352.287.489.261.285.606.438.962.425.185.014.372-.018.546-.095.175-.077.333-.196.466-.35.13-.154.231-.338.296-.54.066-.203.093-.42.081-.637a1.76 1.76 0 0 0-.044-.697 1.571 1.571 0 0 0-.306-.597 1.259 1.259 0 0 0-.502-.369 1.084 1.084 0 0 0-.589-.06h-1.047l.103-1.744ZM22.945 38.715h-6.297v-1.48l2.986-3.934c.352-.475.662-.991.926-1.54.166-.356.26-.751.275-1.156.01-.425-.105-.841-.326-1.176a1.096 1.096 0 0 0-.4-.35.919.919 0 0 0-.492-.096.965.965 0 0 0-.547.115c-.17.092-.32.234-.431.412-.227.423-.341.918-.326 1.42H16.51a4.09 4.09 0 0 1 .185-1.399c.142-.446.359-.854.638-1.197.298-.361.656-.643 1.053-.828.396-.186.821-.27 1.247-.247.821-.056 1.628.272 2.248.913.273.314.486.694.625 1.113.14.42.201.87.181 1.32a3.88 3.88 0 0 1-.446 1.885c-.46.808-.971 1.573-1.527 2.292l-1.716 2.19h3.947v1.743ZM24.108 28.121c-.01-.227.05-.45.17-.628a.644.644 0 0 1 .225-.187.542.542 0 0 1 .27-.057.556.556 0 0 1 .278.054.657.657 0 0 1 .233.19c.12.178.18.401.17.628.012.228-.049.452-.17.629a.645.645 0 0 1-.224.187.544.544 0 0 1-.27.056.557.557 0 0 1-.279-.054.658.658 0 0 1-.233-.19c-.12-.176-.181-.4-.17-.628Zm.375 0a.957.957 0 0 0 0 .365c.025.047.06.086.102.111.042.025.09.036.136.031a.178.178 0 0 0 .122-.032.233.233 0 0 0 .083-.11.697.697 0 0 0 .085-.365.828.828 0 0 0-.05-.304.247.247 0 0 0-.093-.112.192.192 0 0 0-.13-.03.179.179 0 0 0-.12.032.233.233 0 0 0-.084.11.812.812 0 0 0-.085.365l.034-.06ZM28.714 29.885a1.57 1.57 0 0 1-.072.547 1.39 1.39 0 0 1-.252.466 1.246 1.246 0 0 1-.939.365 1.04 1.04 0 0 1-.53-.101 1.233 1.233 0 0 1-.442-.365 1.642 1.642 0 0 1-.29-.542 1.85 1.85 0 0 1-.085-.634v-.77a1.835 1.835 0 0 1 .358-1.176c.264-.275.604-.427.955-.427.352 0 .691.152.956.427.117.127.209.285.268.46.059.176.084.365.073.554h-.648a1.037 1.037 0 0 0-.154-.609.64.64 0 0 0-.23-.163.553.553 0 0 0-.265-.04.53.53 0 0 0-.235.109.654.654 0 0 0-.174.216 1.44 1.44 0 0 0-.17.75v.77c-.015.27.052.535.187.75a.65.65 0 0 0 .219.212c.086.05.18.074.276.072a.48.48 0 0 0 .25-.038.565.565 0 0 0 .21-.164.918.918 0 0 0 .154-.588l.58-.081Z"
		/>
		<rect
			width={ 0.646 }
			height={ 4.018 }
			x={ 30.008 }
			y={ 27.248 }
			fill="#9FA9AF"
			rx={ 0.323 }
		/>
		<path
			fill="#9FA9AF"
			d="M31.947 28.12c-.01-.227.051-.45.17-.628a.644.644 0 0 1 .225-.187.543.543 0 0 1 .27-.056.556.556 0 0 1 .278.054.658.658 0 0 1 .233.19c.12.177.18.4.17.627.012.227-.05.451-.17.628a.643.643 0 0 1-.224.186.544.544 0 0 1-.27.057.556.556 0 0 1-.279-.054.656.656 0 0 1-.233-.19c-.12-.176-.181-.4-.17-.627Zm.375 0a.955.955 0 0 0 0 .364c.025.048.06.086.103.111.042.025.089.036.136.031a.179.179 0 0 0 .12-.032.233.233 0 0 0 .084-.11.694.694 0 0 0 .085-.364.825.825 0 0 0-.05-.304.248.248 0 0 0-.093-.112.192.192 0 0 0-.13-.03.179.179 0 0 0-.12.033.234.234 0 0 0-.084.11.811.811 0 0 0-.085.364l.034-.061ZM36.072 29.598H34.77v1.667h-.65v-4.017h2.246v.623H34.77v1.105h1.368l-.065.622Z"
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 24.922 }
			y={ 37.42 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 17.439 }
			height={ 1.453 }
			x={ 49.627 }
			y={ 42.507 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M66.774 36.887a2.734 2.734 0 0 1-2.73 2.732H57.04a3.132 3.132 0 0 1 0-6.262h.086a2.979 2.979 0 0 1 5.508-.702 1.986 1.986 0 0 1 2.414 1.699 2.739 2.739 0 0 1 1.727 2.533Z"
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 9.781 }
			y={ 42.507 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 19.227 }
			y={ 42.507 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M66.339 61.4h4.36v4.36h-4.36z" />
			</clipPath>
			<clipPath id="b">
				<path fill="#fff" d="M9.663 61.4h-4.36v4.36h4.36z" />
			</clipPath>
		</defs>
	</svg>
);
export const VerticalCardPresetFive = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 90 : 76 }
		height={ isPopup ? 148 : 125 }
		fill="none"
		viewBox="0 0 76 125"
	>
		<rect
			width={ 74.733 }
			height={ 123.733 }
			x={ 0.633 }
			y={ 0.633 }
			fill="#fff"
			rx={ 1.9 }
		/>
		<rect
			width={ 74.733 }
			height={ 123.733 }
			x={ 0.633 }
			y={ 0.633 }
			stroke="#8796A1"
			strokeWidth={ 1.267 }
			rx={ 1.9 }
		/>
		<rect
			width={ 66.122 }
			height={ 115.532 }
			x={ 4.94 }
			y={ 4.234 }
			fill="#fff"
			stroke="#58707F"
			strokeWidth={ 0.727 }
			rx={ 1.817 }
		/>
		<rect
			width={ 61.036 }
			height={ 37.057 }
			x={ 7.483 }
			y={ 80.654 }
			fill="#58707F"
			rx={ 1.453 }
		/>
		<rect
			width={ 17.439 }
			height={ 2.18 }
			x={ 10.39 }
			y={ 83.583 }
			fill="#fff"
			rx={ 1.09 }
		/>
		<rect
			width={ 14.532 }
			height={ 2.18 }
			x={ 51.08 }
			y={ 83.583 }
			fill="#fff"
			rx={ 1.09 }
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 10.39 }
			y={ 90.122 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<path
			fill="#fff"
			d="M39.454 90.849a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 52.533 }
			y={ 90.122 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 59.799 }
			y={ 90.122 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 10.39 }
			y={ 97.389 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<path
			fill="#fff"
			d="M39.454 98.115a2.18 2.18 0 1 1-4.359 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 52.533 }
			y={ 97.389 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 59.799 }
			y={ 97.389 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 10.39 }
			y={ 104.654 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<path
			fill="#fff"
			d="M39.454 105.381a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 52.533 }
			y={ 104.654 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 59.799 }
			y={ 104.654 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 10.39 }
			y={ 111.92 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<path
			fill="#fff"
			d="M39.454 112.647a2.179 2.179 0 1 1-4.358 0 2.179 2.179 0 0 1 4.358 0Z"
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 52.533 }
			y={ 111.92 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 59.799 }
			y={ 111.92 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 18.892 }
			height={ 17.439 }
			x={ 7.483 }
			y={ 60.31 }
			fill="#58707F"
			rx={ 1.453 }
		/>
		<path
			fill="#fff"
			d="M19.11 66.122a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 11.116 }
			y={ 70.118 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 13.296 }
			y={ 72.661 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 18.892 }
			height={ 17.439 }
			x={ 28.555 }
			y={ 60.31 }
			fill="#58707F"
			rx={ 1.453 }
		/>
		<path
			fill="#fff"
			d="M40.181 66.122a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 32.915 }
			y={ 70.118 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 32.552 }
			y={ 72.661 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 18.892 }
			height={ 17.439 }
			x={ 49.627 }
			y={ 60.31 }
			fill="#58707F"
			rx={ 1.453 }
		/>
		<path
			fill="#fff"
			d="M61.253 66.122a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 56.166 }
			y={ 70.118 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.079 }
			height={ 1.453 }
			x={ 52.533 }
			y={ 72.661 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 61.036 }
			height={ 7.993 }
			x={ 7.483 }
			y={ 7.266 }
			fill="#58707F"
			rx={ 1.453 }
		/>
		<path
			fill="#fff"
			d="M27.465 11.262a1.817 1.817 0 1 1-3.633 0 1.817 1.817 0 0 1 3.633 0Z"
		/>
		<rect
			width={ 23.252 }
			height={ 2.18 }
			x={ 28.919 }
			y={ 10.172 }
			fill="#fff"
			rx={ 1.09 }
		/>
		<rect
			width={ 61.036 }
			height={ 4.36 }
			x={ 7.483 }
			y={ 53.043 }
			fill="#58707F"
			rx={ 1.453 }
		/>
		<rect
			width={ 23.252 }
			height={ 1.453 }
			x={ 26.375 }
			y={ 54.496 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 7.483 }
			y={ 17.439 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 58.347 }
			y={ 17.439 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M43.967 28.531a2.735 2.735 0 0 1-2.73 2.732H34.23a3.132 3.132 0 0 1 0-6.262h.087a2.98 2.98 0 0 1 5.508-.701c.148-.035.3-.053.452-.053a1.986 1.986 0 0 1 1.962 1.751 2.738 2.738 0 0 1 1.727 2.533ZM29.884 38.256h1.041c.179.019.358-.01.527-.083.168-.074.32-.19.446-.343.219-.334.328-.752.307-1.176a1.828 1.828 0 0 0-.307-1.094 1.189 1.189 0 0 0-.424-.32 1.022 1.022 0 0 0-.498-.086c-.318-.01-.627.12-.87.365a1.323 1.323 0 0 0-.257.444 1.514 1.514 0 0 0-.084.53h-1.792a3.046 3.046 0 0 1 .194-1.217 2.6 2.6 0 0 1 .642-.973c.6-.588 1.357-.898 2.133-.872.824-.054 1.636.248 2.286.851.274.295.489.66.628 1.067.139.408.198.847.174 1.285 0 .501-.132.99-.375 1.399-.26.452-.62.81-1.04 1.034.47.184.878.548 1.16 1.034.274.47.418 1.03.409 1.601.02.467-.053.932-.213 1.358-.16.426-.403.802-.708 1.095-.673.615-1.506.931-2.355.892-.787.031-1.558-.263-2.184-.83a2.653 2.653 0 0 1-.702-1.05 3.127 3.127 0 0 1-.185-1.323h1.706c-.006.2.024.4.09.586.064.185.162.352.285.489.26.285.603.438.956.425.185.015.37-.018.543-.095.174-.077.332-.196.464-.35.13-.153.23-.337.294-.54.065-.203.093-.42.08-.636a1.769 1.769 0 0 0-.043-.697 1.574 1.574 0 0 0-.304-.597 1.252 1.252 0 0 0-.5-.37 1.072 1.072 0 0 0-.585-.06h-1.041l.102-1.743ZM41.755 45.05h-6.352v-1.5l3.011-3.99a9.648 9.648 0 0 0 .935-1.563c.167-.36.262-.762.277-1.173a2.09 2.09 0 0 0-.33-1.192 1.107 1.107 0 0 0-.403-.355.923.923 0 0 0-.496-.098.97.97 0 0 0-.551.117 1.186 1.186 0 0 0-.436.418c-.229.43-.343.931-.328 1.44h-1.818c-.02-.483.045-.966.187-1.418.143-.453.362-.866.644-1.215.3-.366.662-.652 1.061-.84.4-.188.829-.273 1.258-.25.829-.056 1.643.276 2.268.925.275.32.49.704.63 1.13.141.425.203.882.183 1.338a3.954 3.954 0 0 1-.45 1.913c-.465.819-.98 1.595-1.54 2.324l-1.731 2.221h3.98v1.769ZM43 34.298c-.01-.227.05-.45.17-.629a.645.645 0 0 1 .224-.187.544.544 0 0 1 .27-.056.556.556 0 0 1 .279.054.656.656 0 0 1 .233.19c.12.177.18.4.17.628a1.03 1.03 0 0 1-.17.628.643.643 0 0 1-.225.187.544.544 0 0 1-.27.057.556.556 0 0 1-.278-.054.657.657 0 0 1-.233-.19c-.121-.177-.182-.4-.17-.628Zm.374 0a.957.957 0 0 0 0 .365c.025.047.06.086.103.11.042.026.09.036.136.032a.178.178 0 0 0 .121-.032.233.233 0 0 0 .084-.11.697.697 0 0 0 .085-.365.83.83 0 0 0-.051-.304.247.247 0 0 0-.092-.112.193.193 0 0 0-.13-.03.18.18 0 0 0-.121.032.233.233 0 0 0-.083.11.813.813 0 0 0-.086.365l.034-.061ZM47.606 36.061c.008.187-.016.373-.072.548a1.39 1.39 0 0 1-.253.466 1.246 1.246 0 0 1-.938.365 1.04 1.04 0 0 1-.531-.102 1.233 1.233 0 0 1-.442-.364 1.644 1.644 0 0 1-.29-.542 1.851 1.851 0 0 1-.085-.634v-.77a1.835 1.835 0 0 1 .358-1.176c.265-.275.604-.427.956-.427.351 0 .69.152.955.427.118.127.21.285.268.46.06.176.084.365.074.553h-.649a1.037 1.037 0 0 0-.153-.608.64.64 0 0 0-.23-.163.552.552 0 0 0-.265-.04.53.53 0 0 0-.235.108.653.653 0 0 0-.175.217 1.44 1.44 0 0 0-.17.75v.77c-.015.269.052.535.187.75.059.09.134.162.22.212.085.049.18.074.275.072a.48.48 0 0 0 .25-.038.565.565 0 0 0 .21-.165.919.919 0 0 0 .154-.587l.58-.082ZM43 41.625c-.01-.227.05-.45.17-.628a.642.642 0 0 1 .224-.187.542.542 0 0 1 .27-.056.555.555 0 0 1 .279.054.656.656 0 0 1 .232.19c.12.177.18.4.17.627a1.03 1.03 0 0 1-.17.627.64.64 0 0 1-.224.187.543.543 0 0 1-.27.056.557.557 0 0 1-.278-.053.655.655 0 0 1-.233-.19c-.121-.176-.182-.4-.17-.627Zm.374 0a.959.959 0 0 0 0 .364c.025.048.06.086.103.111.042.025.089.036.136.031a.179.179 0 0 0 .121-.032.234.234 0 0 0 .083-.11.693.693 0 0 0 .086-.364.823.823 0 0 0-.051-.304.248.248 0 0 0-.093-.112.193.193 0 0 0-.129-.03.179.179 0 0 0-.121.033.233.233 0 0 0-.084.11.812.812 0 0 0-.085.364l.034-.061ZM47.124 43.103h-1.302v1.667h-.652v-4.017h2.247v.623h-1.595v1.104h1.367l-.065.623Z"
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 29.281 }
			y={ 47.23 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 38.727 }
			y={ 47.23 }
			fill="#58707F"
			rx={ 0.727 }
		/>
	</svg>
);
export const VerticalCardPresetSix = ( { isPopup = false } ) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={ isPopup ? 90 : 76 }
		height={ isPopup ? 148 : 125 }
		fill="none"
		viewBox="0 0 76 125"
	>
		<rect
			width={ 74.733 }
			height={ 123.733 }
			x={ 0.633 }
			y={ 0.633 }
			fill="#fff"
			rx={ 1.9 }
		/>
		<rect
			width={ 74.733 }
			height={ 123.733 }
			x={ 0.633 }
			y={ 0.633 }
			stroke="#8796A1"
			strokeWidth={ 1.267 }
			rx={ 1.9 }
		/>
		<rect
			width={ 66.122 }
			height={ 115.532 }
			x={ 4.94 }
			y={ 4.234 }
			fill="#fff"
			stroke="#58707F"
			strokeWidth={ 0.727 }
			rx={ 1.817 }
		/>
		<path
			fill="#58707F"
			d="M12.57 10.536a1.817 1.817 0 1 1-3.633 0 1.817 1.817 0 0 1 3.633 0Z"
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 13.296 }
			y={ 9.81 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.173 }
			height={ 1.453 }
			x={ 56.893 }
			y={ 9.81 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<path
			fill="#58707F"
			d="M28.829 27.912a4.253 4.253 0 0 1-4.247 4.25H13.685a4.871 4.871 0 0 1 0-9.741h.134a4.634 4.634 0 0 1 8.568-1.092 3.12 3.12 0 0 1 .704-.081 3.09 3.09 0 0 1 3.052 2.724 4.259 4.259 0 0 1 2.686 3.94ZM33.518 23.804h1.04c.179.019.359-.01.527-.083.168-.074.32-.191.446-.343.22-.334.328-.753.307-1.176a1.828 1.828 0 0 0-.307-1.095 1.188 1.188 0 0 0-.424-.32 1.022 1.022 0 0 0-.497-.085c-.318-.01-.628.12-.87.365a1.325 1.325 0 0 0-.258.443 1.514 1.514 0 0 0-.084.53h-1.791a3.046 3.046 0 0 1 .193-1.216 2.6 2.6 0 0 1 .643-.974c.598-.587 1.356-.897 2.133-.871.823-.054 1.635.248 2.286.851.274.295.488.66.627 1.067.139.407.199.846.175 1.285-.001.501-.132.99-.376 1.399-.26.452-.62.81-1.04 1.034.471.184.879.548 1.16 1.034.275.469.418 1.03.41 1.601a3.45 3.45 0 0 1-.214 1.358c-.16.426-.403.802-.708 1.095-.673.615-1.506.93-2.355.892-.786.03-1.558-.263-2.184-.831a2.652 2.652 0 0 1-.701-1.05 3.127 3.127 0 0 1-.186-1.322h1.706c-.006.2.025.4.09.586.064.185.162.352.286.489.259.285.602.438.955.425.185.014.37-.018.544-.095.173-.077.331-.196.463-.35.13-.153.23-.338.295-.54.064-.203.092-.42.08-.637a1.769 1.769 0 0 0-.044-.696 1.576 1.576 0 0 0-.304-.598 1.255 1.255 0 0 0-.5-.368 1.073 1.073 0 0 0-.585-.06h-1.04l.102-1.744ZM45.388 30.599h-6.352v-1.502l3.011-3.99a9.643 9.643 0 0 0 .935-1.563c.167-.36.262-.761.277-1.172a2.091 2.091 0 0 0-.329-1.193 1.106 1.106 0 0 0-.404-.355.923.923 0 0 0-.496-.097.97.97 0 0 0-.55.117 1.185 1.185 0 0 0-.436.418c-.23.43-.344.931-.33 1.44h-1.817c-.019-.484.045-.966.188-1.419.143-.452.361-.866.643-1.214.3-.366.662-.652 1.062-.84.4-.188.828-.273 1.258-.25.828-.057 1.642.276 2.267.925.276.319.49.704.631 1.13.14.425.203.882.182 1.338a3.955 3.955 0 0 1-.45 1.913c-.464.819-.98 1.595-1.54 2.324l-1.73 2.22h3.98v1.77ZM46.633 19.846c-.01-.227.05-.45.17-.629a.646.646 0 0 1 .225-.187.542.542 0 0 1 .27-.056.557.557 0 0 1 .278.054.657.657 0 0 1 .233.19c.12.177.18.4.17.628.012.227-.05.451-.17.628a.645.645 0 0 1-.224.187.542.542 0 0 1-.27.056.557.557 0 0 1-.279-.053.658.658 0 0 1-.233-.19c-.12-.177-.181-.4-.17-.628Zm.375 0a.957.957 0 0 0 0 .365c.025.047.06.086.102.11.042.026.09.036.136.032a.178.178 0 0 0 .122-.033.233.233 0 0 0 .083-.11.697.697 0 0 0 .085-.364.829.829 0 0 0-.05-.304.247.247 0 0 0-.093-.112.192.192 0 0 0-.13-.03.18.18 0 0 0-.12.032.233.233 0 0 0-.084.11.812.812 0 0 0-.085.365l.034-.061ZM51.239 21.61a1.57 1.57 0 0 1-.072.547 1.39 1.39 0 0 1-.252.466 1.246 1.246 0 0 1-.939.365 1.04 1.04 0 0 1-.53-.102 1.233 1.233 0 0 1-.442-.364 1.644 1.644 0 0 1-.29-.542 1.85 1.85 0 0 1-.086-.634v-.77a1.835 1.835 0 0 1 .359-1.176c.264-.276.604-.427.955-.427.352 0 .691.151.956.427.117.127.209.285.268.46.059.176.084.365.073.553h-.648a1.037 1.037 0 0 0-.154-.608.64.64 0 0 0-.23-.163.553.553 0 0 0-.265-.04.531.531 0 0 0-.235.108.654.654 0 0 0-.174.217 1.44 1.44 0 0 0-.171.75v.77c-.014.269.052.535.188.75.058.09.133.162.219.212.086.049.18.074.276.072a.48.48 0 0 0 .25-.039.565.565 0 0 0 .21-.164.918.918 0 0 0 .154-.588l.58-.08Z"
		/>
		<rect
			width={ 0.646 }
			height={ 4.018 }
			x={ 52.533 }
			y={ 18.973 }
			fill="#9FA9AF"
			rx={ 0.323 }
		/>
		<path
			fill="#9FA9AF"
			d="M54.472 19.845c-.01-.227.051-.45.17-.628a.644.644 0 0 1 .225-.187.543.543 0 0 1 .27-.056.557.557 0 0 1 .278.054.658.658 0 0 1 .233.189c.12.178.18.4.17.628.012.227-.05.45-.17.627a.643.643 0 0 1-.224.187.543.543 0 0 1-.27.056.556.556 0 0 1-.279-.053.656.656 0 0 1-.233-.19c-.12-.176-.181-.4-.17-.627Zm.375 0a.959.959 0 0 0 0 .364c.025.047.06.086.102.11.043.026.09.037.137.032a.178.178 0 0 0 .12-.032.233.233 0 0 0 .084-.11.694.694 0 0 0 .085-.364.825.825 0 0 0-.05-.304.249.249 0 0 0-.093-.112.192.192 0 0 0-.13-.03.179.179 0 0 0-.12.032.234.234 0 0 0-.084.11.811.811 0 0 0-.085.364l.034-.06ZM58.597 21.323h-1.303v1.667h-.65v-4.017h2.246v.622h-1.596V20.7h1.368l-.065.623Z"
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 46.72 }
			y={ 29.064 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 56.166 }
			y={ 29.064 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 37.784 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 34.878 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 27.611 }
			height={ 10.173 }
			x={ 8.937 }
			y={ 42.144 }
			fill="#58707F"
			rx={ 1.09 }
		/>
		<path
			fill="#fff"
			d="M16.929 47.23a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 19.109 }
			y={ 45.231 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 19.109 }
			y={ 47.774 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 27.611 }
			height={ 10.173 }
			x={ 39.455 }
			y={ 42.144 }
			fill="#58707F"
			rx={ 1.09 }
		/>
		<path
			fill="#fff"
			d="M47.448 47.23a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 11.626 }
			height={ 1.453 }
			x={ 49.627 }
			y={ 45.231 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 7.266 }
			height={ 1.453 }
			x={ 49.627 }
			y={ 47.774 }
			fill="#fff"
			rx={ 0.727 }
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 80.654 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 8.937 }
			y={ 84.287 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 58.346 }
			y={ 80.654 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 56.166 }
			y={ 84.287 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<g fill="#58707F" clipPath="url(#a)">
			<path d="M47.716 59.057a.465.465 0 0 0 .66 0 .466.466 0 0 0 0-.66l-.66-.659a.466.466 0 1 0-.66.66l.66.659ZM47.556 61.036c0-.257-.209-.424-.466-.424h-.933c-.257 0-.466.167-.466.424 0 .258.209.424.466.424h.933c.257 0 .466-.166.466-.424ZM50.353 58.238c.258 0 .424-.209.424-.466v-.933c0-.257-.166-.466-.424-.466-.257 0-.423.209-.423.466v.933c0 .257.166.466.423.466ZM52.661 59.194c.12 0 .24-.045.33-.136l.66-.66a.466.466 0 1 0-.66-.659l-.66.66a.466.466 0 0 0 .33.795ZM50.354 58.704a2.334 2.334 0 0 0-2.331 2.331 2.334 2.334 0 0 0 2.33 2.332 2.334 2.334 0 0 0 2.332-2.332 2.334 2.334 0 0 0-2.331-2.33ZM47.716 63.014l-.66.659a.466.466 0 1 0 .66.66l.66-.66a.466.466 0 1 0-.66-.66ZM52.991 63.014a.466.466 0 1 0-.66.659l.66.66a.465.465 0 0 0 .66 0 .466.466 0 0 0 0-.66l-.66-.66ZM54.55 60.612h-.933c-.258 0-.466.167-.466.424 0 .258.208.424.466.424h.933c.257 0 .466-.166.466-.424 0-.257-.209-.424-.466-.424ZM50.353 63.833c-.257 0-.423.209-.423.466v.933c0 .257.166.466.423.466.258 0 .424-.209.424-.466v-.933c0-.257-.166-.466-.424-.466Z" />
		</g>
		<path
			fill="#58707F"
			d="M63.127 80.29c.57 0 1.035-.462 1.004-1.03a19.57 19.57 0 0 0-1.935-7.45c-1.297-2.69-3.197-5.132-5.592-7.19-2.395-2.058-5.239-3.69-8.369-4.804a29.503 29.503 0 0 0-9.87-1.687c-3.388 0-6.743.573-9.872 1.687-3.13 1.114-5.973 2.746-8.368 4.804-2.396 2.058-4.296 4.5-5.592 7.19a19.57 19.57 0 0 0-1.936 7.45c-.03.568.434 1.03 1.004 1.03.57 0 1.029-.462 1.062-1.03a18.008 18.008 0 0 1 1.776-6.772c1.193-2.474 2.941-4.721 5.145-6.614 2.203-1.894 4.82-3.395 7.699-4.42a27.143 27.143 0 0 1 9.081-1.552c3.117 0 6.203.527 9.082 1.552 2.879 1.024 5.495 2.526 7.699 4.42 2.203 1.893 3.951 4.14 5.144 6.614a18.01 18.01 0 0 1 1.776 6.772c.034.568.492 1.03 1.062 1.03Z"
		/>
		<rect
			width={ 20.345 }
			height={ 2.18 }
			x={ 8.937 }
			y={ 90.85 }
			fill="#58707F"
			rx={ 1.09 }
		/>
		<rect
			width={ 14.532 }
			height={ 2.18 }
			x={ 52.533 }
			y={ 90.85 }
			fill="#58707F"
			rx={ 1.09 }
		/>
		<rect
			width={ 8.719 }
			height={ 8.719 }
			x={ 8.937 }
			y={ 96.662 }
			fill="#58707F"
			rx={ 1.453 }
		/>
		<path
			fill="#fff"
			d="M15.476 101.022a2.18 2.18 0 1 1-4.358 0 2.18 2.18 0 0 1 4.358 0Z"
		/>
		<rect
			width={ 8.719 }
			height={ 1.453 }
			x={ 20.563 }
			y={ 98.842 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 13.079 }
			height={ 1.453 }
			x={ 20.563 }
			y={ 101.748 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 0.727 }
			height={ 4.36 }
			x={ 58.346 }
			y={ 98.842 }
			fill="#58707F"
			rx={ 0.363 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 61.252 }
			y={ 98.842 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 61.252 }
			y={ 101.748 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 8.719 }
			height={ 8.719 }
			x={ 8.937 }
			y={ 107.562 }
			fill="#58707F"
			rx={ 1.453 }
		/>
		<path
			fill="#fff"
			d="M15.476 111.921a2.18 2.18 0 1 1-4.36 0 2.18 2.18 0 0 1 4.36 0Z"
		/>
		<rect
			width={ 10.899 }
			height={ 1.453 }
			x={ 20.563 }
			y={ 109.741 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 14.532 }
			height={ 1.453 }
			x={ 20.563 }
			y={ 112.647 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 0.727 }
			height={ 4.36 }
			x={ 58.346 }
			y={ 109.741 }
			fill="#58707F"
			rx={ 0.363 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 61.252 }
			y={ 109.741 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<rect
			width={ 5.813 }
			height={ 1.453 }
			x={ 61.252 }
			y={ 112.647 }
			fill="#58707F"
			rx={ 0.727 }
		/>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M45.267 55.95H55.44v10.172H45.267z" />
			</clipPath>
		</defs>
	</svg>
);
export const WeatherArrowIcon = ( {
	size = 24,
	isDownArrow = false,
	fill = '#4AB866',
} ) => (
	<span
		className={ `spl-weather-${
			isDownArrow ? 'down' : 'up'
		}-arrow-icon sp-d-flex sp-align-i-center` }
	>
		{ size === 24 ? (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={ 24 }
				height={ 24 }
				fill="none"
			>
				<path
					fill={ fill }
					fillRule="evenodd"
					d="m17.53 9.47-1.06 1.06-3.72-3.72V20h-1.5V6.81l-3.72 3.72-1.06-1.06L12 3.94l5.53 5.53Z"
					clipRule="evenodd"
				/>
			</svg>
		) : (
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={ 16 }
				height={ 16 }
				fill="none"
			>
				<path
					fill={ fill }
					fillRule="evenodd"
					d="m12.562 6.313-.707.707-2.48-2.48v8.793h-1V4.54l-2.48 2.48-.707-.707 3.687-3.687 3.687 3.687Z"
					clipRule="evenodd"
				/>
			</svg>
		) }
	</span>
);
